import * as React from 'react';
import './TableAction.scss';

interface TableActionProps {
  icon: React.FC<any>;
  onClick: () => void;
  iconSize?: number;
  tooltip?: string;
}

const TableAction: React.FC<TableActionProps> = ({ icon: Icon, onClick, tooltip, iconSize = 20 }) => {
  const handleClick = React.useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      onClick();
    },
    [onClick]
  );
  return (
    <button
      className="TableAction"
      onClick={handleClick}
      data-tooltip-id="default-tooltip"
      data-tooltip-content={tooltip}
    >
      <Icon width={iconSize} />
    </button>
  );
};

export default TableAction;
